export default {"src":"/_next/static/media/search-all-results.27eafaec.gif","height":300,"width":400};